var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3",style:('float:left; height: 40px; width: 40px; border-radius: 50%; border: solid 6px ' + _vm.color + ';display: inline-block;')},[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }